import dayjs from 'dayjs';
import { Query } from 'graphql/generated/graphqlTypes';
import {
  generateMockNfcCard,
  generateMockNfcCardAssignment,
  generateMockNfcCardAssignmentBlockedInfo
} from 'mocks/graphqlMocks/nfcCard';
import {
  mockVisitor11WithCard,
  mockVisitor12WithBlockedCard,
  mockVisitor19DisconnectedWithCard,
  mockVisitor8ExpiringTomorrow,
  mockVisitor9Expired
} from 'mocks/graphqlMocks/visitorFixtures';

export function mockedGetAllVisitorsCardsWithoutNestedResolversData(
  getNfcCards: Query['getNfcCards']
): Pick<Query, 'getNfcCards'> {
  return { getNfcCards };
}

// Card holders drive the `hasCard` / `noCard` filters and the searchable card column on the Users
// page, so the assignments point at the real visitor fixtures rather than stand-ins — the card name
// is searchable alongside the visitor's own fields.
//
// Of the 8 visitors in the overview table only 11 and 19 hold a card, so `noCard` matches the other
// 6. Visitor 19 has no registered ACCESS device, and holding a card is exactly what makes it
// status 3 rather than status 4 — drop its card and the status column changes.
//
// Visitors 8, 9 and 12 keep their cards too: they are no longer in the overview fixture but still
// back the Cards page and their own detail pages.
export const mockedGetAllVisitorsCardsWithoutNestedResolversDataForQuery =
  mockedGetAllVisitorsCardsWithoutNestedResolversData([
    generateMockNfcCard({ uuid: 'mockedNfcCardUuid1', name: 'Unassigned Card A' }),
    generateMockNfcCard({ uuid: 'mockedNfcCardUuid2', name: 'Unassigned Card B' }),
    generateMockNfcCard({
      uuid: 'mockedNfcCardUuid3',
      name: 'Reception Badge',
      assignment: generateMockNfcCardAssignment({
        expiryDate: dayjs().add(1, 'day').toISOString(),
        visitor: mockVisitor8ExpiringTomorrow,
        visitorName: mockVisitor8ExpiringTomorrow.name
      })
    }),
    generateMockNfcCard({
      uuid: 'mockedNfcCardUuid4',
      name: 'Expired Badge',
      assignment: generateMockNfcCardAssignment({
        expired: true,
        expiryDate: dayjs().subtract(1, 'day').toISOString(),
        visitor: mockVisitor9Expired,
        visitorName: mockVisitor9Expired.name
      })
    }),
    generateMockNfcCard({
      uuid: 'mockedNfcCardUuid5',
      name: 'Blocked Badge',
      assignment: generateMockNfcCardAssignment({
        blocked: generateMockNfcCardAssignmentBlockedInfo({ reason: 'Lost card' }),
        expiryDate: dayjs().add(1, 'year').toISOString(),
        visitor: mockVisitor12WithBlockedCard,
        visitorName: mockVisitor12WithBlockedCard.name
      })
    }),
    generateMockNfcCard({
      uuid: 'mockedNfcCardUuid6',
      name: 'Warehouse Badge',
      assignment: generateMockNfcCardAssignment({
        expiryDate: dayjs().add(1, 'week').toISOString(),
        visitor: mockVisitor11WithCard,
        visitorName: mockVisitor11WithCard.name
      })
    }),
    generateMockNfcCard({
      uuid: 'mockedNfcCardUuid7',
      name: 'Loading Dock Badge',
      assignment: generateMockNfcCardAssignment({
        expiryDate: dayjs().add(6, 'months').toISOString(),
        visitor: mockVisitor19DisconnectedWithCard,
        visitorName: mockVisitor19DisconnectedWithCard.name
      })
    })
  ]);
